import React from "react"
import FaIcon from "components/fa_icon"

function ProgressBadge({change}) {
  if (change === 0) return

  function progress_class(change) {
    if (change > 0) {
      return "positive"
    } else if (change < 0) {
      return "negative"
    }
  }

  return (
    <div className={`badge progress badge--small ${progress_class(change)}`}>
      <FaIcon name={"fa-crooked-arrow"}/>
      {Math.abs(change)}%
    </div>
  )
}

export default ProgressBadge
